import React from "react";
import { api } from "../../../lib/gameApi";
import { ChatRoom } from "./ChatRoom";

export default function PublicChat({ gameId, me, disabled }) {
  return (
    <ChatRoom
      gameId={gameId}
      me={me}
      subcollection="publicChat"
      postMessage={api.postPublicChat}
      inputId="public-chat-input"
      ariaLabel="Public chat"
      placeholder="Enter a message"
      disabled={disabled}
    />
  );
}
